import {
  AsyncActionState,
  asyncActionStateMatchers,
  setupSlice,
  invoke,
} from '@owl-frontend/redux';
import { addUserEvent } from '../../api/userEvents/client';

export interface UserEventState {
  actions: {
    addUserEvent: AsyncActionState;
  };
}

const initialState: UserEventState = {
  actions: {
    addUserEvent: { status: 'uninitialized' },
  },
};

const slice = setupSlice('userEvents', initialState).addAsyncSagas({
  addUserEvent: invoke(addUserEvent),
});

export const actions = slice.actions;
export default slice.addExtra(asyncActionStateMatchers(actions).all());
